<template>
  <div
    class="bblayout"
    :class="{ 'is-iosapp': bridge.isIniOSApp, 'is-androidapp': bridge.isInAndroidApp }"
  >
    <Header :back-black="true" :is-relative="true" :title="'极氪订阅'" :customBack="true" @back="back" />
    <div class="bblayout__content">
      <div class="qrcode">
        <img src="../../../public/images/UnavailableCity-bgimg.png" alt="" class="qrcode__img" />
        <div class="qrcode__text">抱歉，当前城市暂未开通服务</div>
        <div class="qrcode__hint">更多城市陆续开通中，看看附近城市服务</div>
        <div class="simplebtn simplebtn--highlight" @click="toHome">去看看</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import Header from "./component/header.vue";
const bridge = window.bridge
const showToAuth = ref(false);
const back = () => {
  if (bridge.isInAndroidApp) {
    bridge.navigateBack()
  } else {
    bridge.navigateBackRoot()
  }
};
const toHome = () => {
  const path = "app://route/openNative?path=/subscription/Home&isSkipH5=true";
  if (bridge.isInAndroidApp) {
    bridge.toRouter({ route: path });
  } else {
    bridge.navigate({ route: path });
  }
};
const timeId = ref(null);
const checkUserAuth = () => {
  bridge.getSubscriptionInfo().then((subscriptionInfo) => {
    if (subscriptionInfo.success) {
      showToAuth.value = !subscriptionInfo.userAuth;
      if (showToAuth.value) timeId.value = setTimeout(checkUserAuth, 1000);
    }
  });
};
onMounted(() => {
  checkUserAuth();
  if (bridge.isInAndroidApp) {
    bridge.setStatusBar({ isTransparency: true });
    bridge.getStatusHeight().then((subscriptionInfo) => {
      if (subscriptionInfo.success) {
        setStatusHeight(subscriptionInfo.statusHeight / 2);
      }
    });
  }
});
const setStatusHeight = (statusHeight) => {
  const header = document.querySelector(".header");
  if (header) header.setAttribute("style", `padding-top:${statusHeight}px;`);
};
onUnmounted(() => {
  clearTimeout(timeId.value);
});
</script>
<style lang="scss" scoped>
@import url("@/style/bottombarlayout.scss");
@import url("@/style/simplebtn.scss");
.is-androidapp {
  ::v-deep .header {
    padding-top: 50px;
  }
}
.qrcode {
  color: #232323;
  font-size: 28px;
  text-align: center;
  font-weight: 400;
  padding-top: 220px;
}
.qrcode__hint {
  color: #9da2a5;
  margin-top: 14px;
}
.qrcode__text {
  position: relative;
  font-weight: 400;
  margin-top: 80px;
}
.simplebtn {
  width: 368px;
  height: 80px;
  line-height: 80px;
  background: linear-gradient(90deg, #65696b 0%, #25292b 100%);
  margin: 90px auto;
}
.qrcode__img {
  width: 490px;
}
</style>
